import { newModalFromSelector, ModalShowHide } from '../components/modal';
import Map from '../components/map';
import StoreHours from 'storeLocator/storeHours';
import { woosmapInitFindInStore, woosmapInitUPS, woosmapListenerForModalClose } from '../woosmap';
import { applyRendering } from '../util/render';

/**
 * Use the browser navigation to get the user's location
 *
 * @param {Object} options to use with getCurrentPosition
 */
export function getPosition (options = {}) {
    return new Promise(function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });
}

export const isSizeSelected = () => {
    if ($('.page-checkout').length > 0 || $('.cart-page').length > 0) {
        return true;
    }
    return $('[data-attr="size"] input:checked').length > 0;
};

export function addLabelToLocation (labelIndex) {
    let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let label = '';
    let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
    let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
    label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
    return label;
}

export class FindInStore {
    constructor () {
        this.coordinates = {};
        this.isGeolocalized = false;
        this.wasMapInitialized = false;
        this.elementSelector = '#findinstore';
        this.radiusSelector = 'input[name="fis-radius"]';
        this.querySelector = 'input[name="query"]';
        this.isCheckAvailability = true;
        this.btnSelector = '.find-in-store-btn';
        if ($('meta[http-equiv=content-language]').attr('content') == 'ja-JP') {
            this.minCharSearch = 2;
        } else {
            this.minCharSearch = 3;
        }
    }

    run (isCheckAvailability = true) {
        // Define elements from DOM
        this.$element = $(this.elementSelector);
        this.geocodingApiKey = $('[data-geocoding-apikey]').data('geocoding-apikey');
        this.countryCode = $('.findinstore[data-country-code]').data('country-code');
        this.url = $(this.btnSelector).data('url');

        // Create Modal and attach event listeners to the interface
        this.modal = new ModalShowHide(this.elementSelector);
        this.addEventListeners();
        this.addInfoWindowEventListeners();
        if (!isCheckAvailability || $('.page').data('action').indexOf('Cart-Show') > -1) {
            this.isCheckAvailability = false;
        }
        this.selectSize();
        const $pickupPointElement = $('#pickupPointData');
        if ($pickupPointElement) {
            // Checkout with pickup point method
            this.pickupPointUrl = $('#pickupPointData').data('url');
            this.btnSelectorPickupPoint = '.pickup-point-btn'; // button for find pickup point
            this.addEventListenersPickupPoint();
        }

        this.woosmapListener();
        woosmapListenerForModalClose();

        // Manage updated modal available only in cart or checkout
        this.isCartOrCheckout = $('#findinstoreResultCheckoutTemplate').length > 0;
        if (this.isCartOrCheckout) {
            this.observeViewMore();
        }
    }

    addEventListeners () {
        // Add button event to launch find-in-store
        let selector = this.btnSelector + '.js-select-store,' + this.btnSelector + '.js-change-store';
        $('body').on('click', selector, (e) => {
            if (isSizeSelected()) {
                if (this.sizeModal && this.sizeModal.modal) {
                    this.sizeModal.close();
                }
                $('.persButtonPdpPers').hide();
                $('.findinstore-wrapper').data('type', 'Pickup');
                this.launch();
            } else {
                // If no size is selected, enable attribute selectors, open modal to choose one
                this.sizeModal = newModalFromSelector('fis-select-size', false, ['fis-select-size-modal']);
                $(this.sizeModal.modalBox).find('.size-selector').removeAttr('disabled');
                $(this.sizeModal.modalBox).find('.size-selector').removeClass('notifyMe');
                $(this.sizeModal.modalBox).find('.notifyIcon').remove();
                this.sizeModal.open();
                $(this.sizeModal.modalBox).find('.alertNotify').hide();
                $(this.sizeModal.modalBox).on('click', '.modal__closeIcon', (e) => {
                    this.sizeModal.close();
                    this.sizeModal.destroy();
                });
            }
            $('.input-text-woosmap').prop('id', 'input-text-woosmap-findinstore');
            woosmapInitFindInStore();
            $('body').trigger('product:moreInfoToggle', 'find_in_store');
            e.preventDefault();
        });

        $('body').on('click', '#findinstore-usecurrentposition', (e) => {
            this.$element.find('.localities-empty-button').trigger('click');
            this.detectLocation();
            e.preventDefault();
            e.stopPropagation();
            $('body').trigger('checkout:geolocationSucceeded');
        });

        $('body').on('focusin', '.localities-input-wrapper', (e) => {
            $(e.currentTarget).closest('.form-item').find('.form-control-label').css('opacity', '1');
        });
        $('body').on('focusout', '.localities-input-wrapper', (e) => {
            $(e.currentTarget).closest('.form-item').find('.form-control-label').css('opacity', '0');
        });

        $('.storeLocatorNearbyList').on('click', function () {
            $('.result').show();
            $('.map-canvas').hide();
            $('.storeLocatorNearbyMap').addClass('change-opacity');
            $('.view-more-button-cell').addClass('view-more-map-close').removeClass('view-more-map-open');
            $('.storeLocatorNearbyList').removeClass('change-opacity');
        });

        $('.storeLocatorNearbyMap').on('click', function () {
            $('.map-canvas').show().addClass('map-canvas-map-open');
            $('.result').hide();
            $('.view-more-button-cell').addClass('view-more-map-open').removeClass('view-more-map-close');
            $('.storeLocatorNearbyList').addClass('change-opacity');
            $('.storeLocatorNearbyMap').removeClass('change-opacity');
        });

        $('body').on('click', '.js-choose-store', (e) => {
            const selectedStoreId = e.target.dataset.storeId;

            const storeName = $(e.target).closest('.result').find('.store-name');
            const storeAddress = $(e.target).closest('.result').find('.js-store-address-row1');
            const storeCity = $(e.target).closest('.result').find('.js-store-city');
            const storePhone = $(e.target).closest('.result').find('.js-store-phone');

            $('.js-store-name').html(storeName.html());
            $('.js-store-address1').html(storeAddress.html());
            $('.js-store-address2').html(storeCity.html());
            $('.js-store-phone').attr('href', storePhone.attr('href'));
            $('.js-store-phone').html(storePhone.html());
            $('.js-select-store').hide();
            $('.js-change-store').show();
            $('.shipping-method-selected.shop-selected').addClass('fix-margin');
            $('.selectedStoreRecap').show();

            $('body').trigger('findinstore:selectedStore', selectedStoreId);
            this.modal.hide();
            $('.localities-container').addClass('hidden');
        });

        // Handle Geocoding request (look for city, zipcode, ..)
        $('body').on('submit', '#findinstore-form', (e) => {
            // TODO: Instead of google geocode, center map on coordinates
            /*
            const query = $(e.currentTarget).find(this.querySelector).val();
            // Lock geocoding button
            $(e.currentTarget).find('input[type="button"]').attr('disabled', 'disabled');
            this.map.geocode(query, this.countryCode, this.$element);
            */
            e.preventDefault();
        });

        // Handle Geocoding update event
        $('body').on('geocode:update', this.$element, (e, res) => {
            if (res.success) {
                // Set active coordinates according to Google Geocoding's response
                this.coordinates.lat = res.data.lat;
                this.coordinates.long = res.data.long;
                // Update map with current coordinates
                this.map.updateCoordinates(this.coordinates);
                this.getStores();
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Google failed: ' + res.status);
                $.spinner().stop();
            }
            // Remove loading state from geocoding button
            $('#findinstore-form').find('input[type="button"]').removeAttr('disabled');
        });

        // Handle typing in search field
        $('body').on('keyup', this.querySelector, (e) => {
            const $searchButton = $(this.querySelector).parent().find('[type="submit"]');

            if ($(this.querySelector).val().length < this.minCharSearch) {
                $searchButton.attr('disabled', 'disabled');
            } else {
                $searchButton.removeAttr('disabled');
            }
        });

        // Handle Radius button change
        $('body').on('change', this.radiusSelector, (e) => {
            var buttonSelected = $('.findinstore-wrapper').data('type');
            if (buttonSelected === 'PUP') {
                this.getStoresPickupPoint();
            } else {
                this.getStores();
            }
            e.preventDefault();
        });

        // Handle "show on map" click
        $('body').on('click', '.fis-show-on-map', (e) => {
            $(window).on('resize', function (e) {
                checkScreenSize();
            });
            checkScreenSize();
            function checkScreenSize () {
                var newWindowWidth = $(window).width();
                if (newWindowWidth < 1080) {
                    $('.map-canvas').show().addClass('map-canvas-map-open');
                    $('.result').hide();
                    $('.view-more-button-cell').addClass('view-more-map-open').removeClass('view-more-map-close');
                    $('.storeLocatorNearbyList').addClass('change-opacity');
                    $('.storeLocatorNearbyMap').removeClass('change-opacity');
                }
            }
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };

            this.map.centerMapOnCoordinates(coords);
            this.scrollToMap();
            e.preventDefault();
            e.stopPropagation();
        });
    }

    detectLocationPickupPoint () {
        getPosition()
            .then((position) => {
                this.isGeolocalized = true;
                // Set active coordinates according to the browser's navigator
                this.coordinates.lat = position.coords.latitude;
                this.coordinates.long = position.coords.longitude;

                this.map.updateCoordinates(this.coordinates);
                this.getStoresPickupPoint();
                const query = this.coordinates;
                this.map.geocode(query);
                $('body').trigger('storeLocator:geolocationSucceeded', { action: 'shipping_method' });
            })
            .catch((err) => {
                // User geolocation not available, log error to the console as warning
                console.warn(err.message);
                $('#findinstore-usecurrentposition').addClass('disabled');
            });
    }

    selectSize () {
        // Handle click on select size modal buttons
        $('body').on('click', '.fis-select-size-modal button.size-selector', (e) => {
            const sizeValue = $(e.currentTarget).data('attr-value');
            $(e.currentTarget).closest('ul').find('button').not(e.currentTarget).removeClass('selected');
            $(e.currentTarget).addClass('selected');

            $('.fis-select-size-modal .find-in-store-size-select-btn').removeAttr('disabled');
            $(this.btnSelector).data('size-value', sizeValue);
            e.stopPropagation();
        });

        $('body').on('click', '.find-in-store-size-select-btn', (e) => {
            if ($('.fis-select-size-modal .find-in-store-size-select-btn').data('size-value') !== '') {
                this.launch();
            }
            e.stopPropagation();
        });
    }

    launchPickupPoint () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitialized) {
            this.initMap();
        }

        // If no coordinates are set, attempt to locate user and get stores
        if (!this.hasCoordinates()) {
            this.detectLocationPickupPoint();
        } else {
            // Otherwise, just get the stores with the current information
            this.getStoresPickupPoint();
        }
        if (this.sizeModal && this.sizeModal.modal) {
            this.sizeModal.close();
            this.sizeModal.destroy();
        }
        this.modal.show();
    }

    addEventListenersPickupPoint () {
        // Add button event to launch pickup-point
        $('body').on('click', this.btnSelectorPickupPoint, (e) => {
            $('.findinstore-wrapper').data('type', 'PUP');
            this.launchPickupPoint();
            $('.input-text-woosmap').prop('id', 'input-text-woosmap-ups');
            woosmapInitUPS();
            e.preventDefault();
        });

        $('body').on('click', '.js-choose-point', (e) => {
            const selectedStoreId = e.target.dataset.storeId;

            const storeName = $(e.target).closest('.result').find('.store-name');
            const storeAddress1 = $(e.target).closest('.result').find('.js-store-address-row1');
            const storeCity = $(e.target).closest('.result').find('.js-store-city');
            const storePostalCode = $(e.target).closest('.result').find('.js-store-postal-code');
            const selectedStoreName = storeName.html();
            const address1 = storeAddress1.html();
            const city = storeCity.html();
            const postalCode = storePostalCode.html();

            $('.selectedPickupPointRecap .js-point-name').html(selectedStoreName);
            $('.selectedPickupPointRecap .js-point-address1').html(address1);
            $('.selectedPickupPointRecap .js-point-city').html(city);
            $('.selectedPickupPointRecap .js-point-postal-code').html(postalCode);
            $('.js-select-point').hide();
            $('.js-change-point').show();
            $('.shipping-method-selected.shop-selected').addClass('fix-margin');
            $('.selectedPickupPointRecap').show();

            const data = {
                number: selectedStoreId,
                name: selectedStoreName,
                address1: address1,
                city: city,
                postalCode: postalCode
            };

            $('body').trigger('pickupoint:selectedPickup', data);
            this.modal.hide();
            $('.localities-container').addClass('hidden');
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
        });

        $('body').on('click', '.show-on-map-from-outside-popup-pickup-point', (e) => {
            this.launchPickupPoint();
        });

        $('body').off('click', '#findinstore-usecurrentposition');

        $('body').on('click', '#findinstore-usecurrentposition', (e) => {
            var buttonSelected = $('.findinstore-wrapper').data('type');
            if (buttonSelected === 'PUP') {
                this.detectLocationPickupPoint();
            } else {
                this.detectLocation();
            }
            e.preventDefault();
            e.stopPropagation();
            $('body').trigger('checkout:geolocationSucceeded');
        });

        // For avoid findinstore listener
        $('body').off('geocode:update');

        // Handle Geocoding update event
        $('body').on('geocode:update', this.$element, (e, res) => {
            if (res.success) {
                // Set active coordinates according to Google Geocoding's response
                this.coordinates.lat = res.data.lat;
                this.coordinates.long = res.data.long;
                // Update map with current coordinates
                this.map.updateCoordinates(this.coordinates);
                var buttonSelected = $('.findinstore-wrapper').data('type');
                if (buttonSelected === 'PUP') {
                    this.getStoresPickupPoint();
                } else {
                    this.getStores();
                }
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Google failed: ' + res.status);
            }

            // Remove loading state from geocoding button
            $('#findinstore-form').find('input[type="button"]').removeAttr('disabled');
        });

        $('body').on('click', '.js-choose-point-infowindow', (e) => {
            const selectedStoreId = e.target.dataset.storeId;

            const $result = $('#fis-results').find('.result').filter(`[data-store-id="${selectedStoreId}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.store-name');
            const storeAddress1 = $result.find('.js-store-address-row1');
            const storeCity = $result.find('.js-store-city');
            const storePostalCode = $result.find('.js-store-postal-code');

            const selectedStoreName = storeName.html();
            const address1 = storeAddress1.html();
            const city = storeCity.html();
            const postalCode = storePostalCode.html();

            $('.selectedPickupPointRecap .js-point-name').html(selectedStoreName);
            $('.selectedPickupPointRecap .js-point-address1').html(address1);
            $('.selectedPickupPointRecap .js-point-city').html(city);
            $('.selectedPickupPointRecap .js-point-postal-code').html(postalCode);

            $('.js-select-point').hide();
            $('.js-change-point').show();

            $('.selectedPickupPointRecap').show();

            const data = {
                number: selectedStoreId,
                name: selectedStoreName,
                address1: address1,
                city: city,
                postalCode: postalCode
            };

            $('body').trigger('pickupoint:selectedPickup', data);
            this.modal.hide();
            $('.localities-container').addClass('hidden');
        });
    }

    launch () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitialized) {
            this.initMap();
        }

        // If no coordinates are set, attempt to locate user and get stores
        if (!this.hasCoordinates()) {
            this.detectLocation();
        } else {
            // Otherwise, just get the stores with the current information
            this.getStores();
        }

        if (this.sizeModal && this.sizeModal.modal) {
            this.sizeModal.close();
            this.sizeModal.destroy();
        }
        this.modal.show();
    }

    detectLocation () {
        getPosition()
            .then((position) => {
                this.isGeolocalized = true;
                // Set active coordinates according to the browser's navigator
                this.coordinates.lat = position.coords.latitude;
                this.coordinates.long = position.coords.longitude;

                this.map.updateCoordinates(this.coordinates);
                this.getStores();
                const query = this.coordinates;
                this.map.geocode(query);
                $('body').trigger('storeLocator:geolocationSucceeded', { action: 'shipping_method' });
            })
            .catch((err) => {
                // User geolocation not available, log error to the console as warning
                console.warn(err.message);
                $('#findinstore-usecurrentposition').addClass('disabled');
            });
    }

    searchForStores (resetStep = true) {
        if (!this.hasCoordinates()) {
            return;
        }
        const self = this;

        // Data to send with the request
        const pid = $('body').find('[data-master-pid]').data('master-pid');
        const color = $('[data-attr="color"] .swatch-value.selected').data('attr-value');
        var rad = this.$element
            .find(this.radiusSelector)
            .filter(':checked')
            .val();

        const radiusValue = this.$element
            .find(this.radiusSelector)
            .filter(':checked')
            .siblings('.radio-label')
            .text().trim();

        let size;

        if (isSizeSelected()) {
            size = $('[data-attr="size"] input:checked').data('attr-value');
        } else {
            size = $(this.btnSelector).data('size-value');
        }

        if (!rad) {
            const dataContainer = $('.findinstore.findinstore-checkout');
            if (resetStep) {
                rad = parseInt(dataContainer.data('base-step'));
            } else {
                rad = parseInt(dataContainer.attr('data-current-step'));
            }
        }

        const payload = {
            lat: this.coordinates.lat,
            lon: this.coordinates.long,
            pid,
            color,
            rad,
            size
        };

        $.spinner().start();

        if (this.url) {
            $.ajax({
                url: this.url,
                type: 'get',
                data: payload,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        self.handleStoresResults(res.stores, res.resources, res, radiusValue);
                    }
                }
            });
        }
    }

    searchForStoresPickupPoint (resetStep) {
        if (!this.hasCoordinates()) {
            return;
        }
        const self = this;

        // Data to send with the request
        let dataContainer = $('.findinstore-wrapper');
        let rad = 1;

        if (resetStep) {
            rad = parseInt(dataContainer.data('base-step-pickup-point'));
        } else {
            rad = dataContainer.attr('data-next-step-pickup-point') ? parseInt(dataContainer.attr('data-next-step-pickup-point')) : parseInt(dataContainer.data('base-step-pickup-point'));
        }

        const radiusValue = this.$element
            .find(this.radiusSelector)
            .filter(':checked')
            .siblings('.radio-label')
            .text().trim();

        const payload = {
            lat: this.coordinates.lat,
            lon: this.coordinates.long,
            rad: rad,
            pid: undefined,
            color: undefined,
            size: undefined
        };

        $.spinner().start();

        if (this.pickupPointUrl) {
            $.ajax({
                url: this.pickupPointUrl,
                type: 'get',
                data: payload,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        self.handleStoresResultsPickupPoint(res.stores, res.resources, radiusValue);
                    }
                }
            });
        }

        $.spinner().stop();
    }

    initMap () {
        const _actualInitMap = () => {
            // Create new Google Map with target and initial center on IP-detected geolocation
            let initialCoordinates = [0, 0];
            const initialCoordinatesString = $('.findinstore[data-geolocation]').data('geolocation');

            if (typeof initialCoordinatesString === 'string' && initialCoordinatesString.length) {
                initialCoordinates = initialCoordinatesString.split(',');
            }

            this.map = new Map(this.$element.find('#map'), [Number(initialCoordinates[0]), Number(initialCoordinates[1])]);
            this.map.init();
            this.wasMapInitialized = true;
        };
        if (typeof google === 'undefined') {
            const apiKey = $('.findinstore[data-maps-api-key]').data('maps-api-key');
            window.googleMapsApiLazyValue = loadGoogleMapsApi(apiKey);
            window.googleMapsApiLazyValue()
                .then((maps) => { _actualInitMap(); });
        } else {
            _actualInitMap();
        }
    }

    hasCoordinates () {
        return this.coordinates.lat && this.coordinates.long;
    }
    addInfoWindowEventListeners () {
        $('body').on('click', '.js-choose-store-infowindow', (e) => {
            const selectedStoreId = e.target.dataset.storeId;
            const $result = $('#fis-results').find('.result').filter(`[data-store-id="${selectedStoreId}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.store-name');
            const storeAddress = $result.find('.js-store-address-row1');
            const storeCity = $result.find('.js-store-city');
            const storePhone = $result.find('.js-store-phone');

            $('.js-store-name').html(storeName.html());
            $('.js-store-address1').html(storeAddress.html());
            $('.js-store-address2').html(storeCity.html());
            $('.js-store-phone').attr('href', storePhone.attr('href'));
            $('.js-store-phone').html(storePhone.html());
            $('.js-select-store').hide();
            $('.js-change-store').show();
            $('.selectedStoreRecap').show();

            $('body').trigger('findinstore:selectedStore', selectedStoreId);
            this.modal.hide();
        });
    }
    getStores () {
        this.searchForStores();
    }

    getStoresPickupPoint () {
        this.searchForStoresPickupPoint(true);
    }

    observeViewMore () {
        var _self = this;
        $('.findinstore.findinstore-checkout').on('click', '.view-more-button', function (e) {
            _self.searchForStores(false);
        });
    }

    handleStoresResults (stores, resources, result, radius) {
        // Fit bounds to markers
        if (this.map) {
            this.map.updateMarkers(stores, resources, this.isCartOrCheckout);
        }

        const $target = $('#fis-results');
        $target.empty();

        // Manage cart and checkout modal with template
        if (this.isCartOrCheckout) {
            const dataContainer = $('.findinstore.findinstore-checkout');
            dataContainer.attr('data-current-step', result.currentStep);
        }

        if ($target.length) {
            let html = '';
            if (this.isCartOrCheckout) {
                $('.js-store-total').text(resources.summary);
                $('.store-locator-nearby-box').css('display', 'flex');
                $(window).on('resize', function (e) {
                    checkScreenSize();
                });
                checkScreenSize();

                function checkScreenSize () {
                    var newWindowWidth = $(window).width();
                    if (newWindowWidth < 1080) {
                        $('.map-canvas').hide();
                    }
                }
            } else {
                html += `<p>${resources.summary.replace('RADIUS', radius)}</p>`;
            }
            const selectedStoreId = $('#storeId').val();

            if (stores.length) {
                var _self = this;
                stores.map((store) => {
                    const isSelected = store.store.ID == selectedStoreId;
                    if (_self.isCartOrCheckout) {
                        html += this.renderResultWithTemplate(store, isSelected);
                    } else {
                        html += this.renderResult(store, resources);
                    }
                });
            }

            if (this.isCartOrCheckout && result.showMoreEnabled) {
                html += applyRendering('viewMoreButtonTemplate');
            }

            $target.html(html);
        }

        // Add store hours
        StoreHours.run();
        $(this.modal.$el).spinner().stop();
    }

    handleStoresResultsPickupPoint (stores, resources, radius) {
        // Fit bounds to markers
        if (this.map) {
            this.map.updateMarkers(stores, resources, this.isCartOrCheckout);
        }
        const $target = $('#fis-results');
        $target.empty();

        if ($target.length) {
            let html = `<p>${resources.summary.replace('RADIUS', radius)}</p>`;
            const selectedStoreId = $('#pickUpPointNumber').val();
            // const selectedStoreName = $('#pickUpPointName').val();

            if (stores.length) {
                stores.map((store) => {
                    const isSelected = store.store.ID == selectedStoreId;
                    html += this.renderResultPickupPoint(store, resources, isSelected);
                });
                $('.map-canvas').removeClass('hide');
                $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: stores[0].store.city });
            }

            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();
    }

    // from outside popup
    handleStoresResultsFromOutsidePopup (stores, resources, radius, e, findInStoreIntimissimiData) {
        // Fit bounds to markers
        if (this.map) {
            this.map.updateMarkers(stores, resources);
        }

        const $target = $('#fis-results');
        $target.empty();

        if ($target.length) {
            let html = `<p>${resources.summary.replace('RADIUS', radius)}</p>`;

            if (stores.length) {
                stores.map((store) => {
                    html += this.renderResult(store, resources);
                });
            }

            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();

        e.preventDefault();
        e.stopPropagation();
        const coords = {
            lat: Number($(e.currentTarget).data('coords').split(',')[0]),
            lng: Number($(e.currentTarget).data('coords').split(',')[1])
        };

        findInStoreIntimissimiData.map.centerMapOnCoordinates(coords);
        findInStoreIntimissimiData.scrollToMap();
    }

    renderResult (data, resources) {
        let buttonFragment = `<p class="small strong ${data.availability === 'high' ? 'text-brand-green' : 'text-medium-gray'} text-right">${data.availabilityLabel}</p>`;
        let storeHours = '';
        let storeHoursList = '';
        let storeHoursListLabel = '';
        let toggleDropdownIcon = '';

        if (this.isCheckAvailability === false) {
            buttonFragment = `<button class="button wide js-choose-store rounded" data-store-id="${data.store.ID}">${resources.select}</button>`;
        } else if ('storeHours' in data.store) {
            storeHours = `
                <span class="store-hours-${data.store.ID}">
                    <span class="store-hours-open hidden">${data.storeOpenLabel}</span>
                    <span class="store-hours-closed hidden">${data.storeClosedLabel}</span>
                </span>
                <span class="store-hours-next-phase">
                    <span class="store-hours-open-until hidden">${data.storeOpenUntilLabel} </span>
                    <span class="store-hours-reopens-at hidden">${data.storeReopensLabel} </span>
                </span>`;

            storeHoursList = data.store.storeHours;

            for (var i = 0; i < storeHoursList.length; i++) {
                storeHoursListLabel += `
                    <li data-name="${storeHoursList[i].name}" data-phases="${storeHoursList[i].hasPhases ? storeHoursList[i].phases : false}" data-first-phase="${storeHoursList[i].firstPhase}">
                        ${storeHoursList[i].label} ${storeHoursList[i].phases}
                    </li>
                `;
            }

            toggleDropdownIcon = `<svg class="toggle-store-hours-dropdown"><use xlink:href="${data.toggleDropdownIcon}" /></svg>`;
        }

        return `
            <div class="grid-x result" data-store-id="${data.store.ID}">
                <div class="cell shrink">
                    <i class="fas fa-lg fa-map-marker-alt text-primary"></i>
                </div>
                <div class="cell auto js-store-row">
                    <div class="store-details">
                        <p class="distance no-margin">
                            <span class="store-name capitalize bold">${data.store.name}</span>
                        </p>
                        <div class="store-details-info">
                            <p class="no-margin">
                                <span class="js-store-address-row1">${data.store.address1}</span>
                            </p>
                            <p class="no-margin"><span class="js-store-city">${data.store.city}, ${data.store.postalCode}</span></p>
                        </div>
                    </div>
                    <div class="grid-x align-middle">
                        <div class="cell grid-x store-hours-cell">
                            <div class="cell store-hours ${this.isCheckAvailability === false ? 'hidden' : ''}" data-store-id="${data.store.ID}">
                                <a href="#" class="js-toggle-store-hours no-hover">
                                    ${toggleDropdownIcon}
                                    ${storeHours}
                                </a>
                                <div class="store-hours-list hidden">
                                    <ul>
                                        ${storeHoursListLabel}
                                    </ul>
                                </div>
                            </div>
                            ${typeof data.store.phone !== 'undefined' ? '<div class="cell"><a class="js-store-phone" href="tel:' + data.store.phone + '">' + data.store.phone + '</a></div>' : ''}
                        </div>
                        <div class="cell small-6">
                            <a target="_blank" class="bold fis-show-on-map font-normal force-hover" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-6 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                </div>
            </div>`;
    }

    renderResultWithTemplate (data, isSelected = false) {
        let storeHoursLabel = '';
        for (let i = 0; i < data.store.storeHours.length; i++) {
            let storeHours = data.store.storeHours[i];
            storeHoursLabel += `
                <li data-name="${storeHours.name}" data-phases="${storeHours.hasPhases ? storeHours.phases : false}" data-first-phase="${storeHours.firstPhase}">
                    ${storeHours.label} ${storeHours.phases}
                </li>
            `;
        }

        const storeResultData = {
            isSelected: isSelected ? 'result--selected' : '',
            id: data.store.ID,
            name: data.store.name,
            address1: data.store.address1,
            distance: this.isGeolocalized ? (data.distance ? data.distance : data.store.distance) : '',
            city: data.store.city,
            postalCode: data.store.postalCode,
            phone: data.store.phone,
            lat: data.store.latitude,
            long: data.store.longitude,
            isTemporaryClosed: data.store.custom.isTemporaryClosed,
            reopeningDate: data.store.custom.reopeningDate || false,
            storeHours: storeHoursLabel
        };
        return applyRendering('findinstoreResultCheckoutTemplate', storeResultData);
    }

    renderResultPickupPoint (data, resources) {
        let buttonFragment = `<p class="small strong ${data.availability === 'high' ? 'text-brand-green' : 'text-medium-gray'} text-right">${data.availabilityLabel}</p>`;
        if (this.isCheckAvailability === false) {
            buttonFragment = `<button class="button wide js-choose-point rounded" data-store-id="${data.store.ID}">${resources.select}</button>`;
        }

        return `
            <div class="grid-x result" data-store-id="${data.store.ID}">
                <div class="cell shrink">
                    <i class="fas fa-lg fa-map-marker-alt text-primary"></i>
                </div>
                <div class="cell auto js-store-row">
                    <div class="store-details">
                        <p class="distance no-margin">
                            <span class="store-name capitalize bold">${data.store.name}</span>
                        </p>
                        <div class="store-details-info notranslate">
                            <p class="no-margin">
                                <span class="js-store-address-row1">${data.store.address1}</span>
                            </p>
                            <p class="no-margin">
                                <span class="js-store-city uppercase">${data.store.city}</span>, <span class="js-store-postal-code">${data.store.postalCode}</span>
                            </p>
                            ${typeof data.store.phone !== 'undefined' ? '<p class="no-margin"><a class="force-hover js-store-phone" href="tel:' + data.store.phone + '">' + data.store.phone + '</a></p>' : ''}
                        </div>
                    </div>
                    <div class="grid-x align-middle">
                        <div class="cell small-6">
                            <a target="_blank" class="bold fis-show-on-map force-hover" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-6 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                </div>
            </div>`;
    }

    renderResultOutsidePopup (data, resources, isSelected = false) {
        let buttonFragment = `<p class="small strong ${data.availability === 'high' ? 'text-brand-green' : 'text-medium-gray'} text-right">${data.availabilityLabel}</p>`;
        if (this.isCheckAvailability === false) {
            buttonFragment = `<button type="button" class="button wide js-choose-store rounded" data-store-id="${data.store.ID}">${resources.select}</button>`;
        }

        return `
            <div class="grid-x pickup-instore-result result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.store.ID}">
                <div class="cell shrink">
                    <i class="fas fa-lg fa-map-marker-alt marker-icon text-primary"></i>
                </div>
                <div class="cell auto js-store-row">
                    <div class="store-details">
                        <p class="distance no-margin">
                            <span class="store-name capitalize bold js-store-address-row1">${data.store.address1}</span>
                            <span class="float-right margin-distance store-distance js-store-distance">${data.distance || ''}</span>
                        </p>
                        <div class="store-details-info">
                            <p class="no-margin">
                                <span class="js-store-city uppercase">${data.store.city}, ${data.store.postalCode}</span>
                            </p>
                            <p class="no-margin">
                                <span class="js-store-info-collection">${data.store.infoCollection ? data.store.infoCollection : ''}</span>
                            </p>
                        </div>
                    </div>
                    <div class="grid-x align-middle">
                        <div class="cell small-6">
                            <a target="_blank" class="bold font-normal force-hover show-on-map-from-outside-popup fis-show-on-map" data-coords="${data.store.latitude},${data.store.longitude}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-6 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                </div>
            </div>`;
    }

    scrollToMap () {
        // Show Map and scroll to it
        const $map = this.$element.find('#map');
        const $wrapper = $map.closest('.findinstore-wrapper');
        $map.show();

        $wrapper.animate({
            scrollTop: $wrapper.get(0).scrollHeight
        });
    }

    woosmapListener () {
        var _self = this;

        $('body').on('woosmap:chooseOptionFindInStore', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                // Set active coordinates according to Google Geocoding's response
                _self.coordinates.lat = selection.geometry.location.lat;
                _self.coordinates.long = selection.geometry.location.lng;
                // Update map with current coordinates
                _self.map.updateCoordinates(_self.coordinates);
                _self.getStores();
                var name = selection.name;
                $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: name });
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
                $.spinner().stop();
            }
        });

        $('body').on('woosmap:chooseOptionUPS', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                // Set active coordinates according to Google Geocoding's response
                _self.coordinates.lat = selection.geometry.location.lat;
                _self.coordinates.long = selection.geometry.location.lng;
                // Update map with current coordinates
                _self.map.updateCoordinates(_self.coordinates);
                _self.getStoresPickupPoint();
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
                $.spinner().stop();
            }
        });
    }
}

const lazyValue = (fn) => {
    let called = false;
    let returnValue;

    return () => {
        if (!called) {
            called = true;
            returnValue = fn();
        }

        return returnValue;
    };
};

let googleMapsScriptIsInjected = false;

const injectGoogleMapsApiScript = (options = {}) => {
    if (googleMapsScriptIsInjected) {
        throw new Error('Google Maps Api is already loaded.');
    }

    const optionsQuery = Object.keys(options)
        .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(options[k])}`)
        .join('&');

    const url = `https://maps.googleapis.com/maps/api/js?${optionsQuery}`;

    const script = document.createElement('script');

    script.setAttribute('src', url);
    script.setAttribute('async', '');
    script.setAttribute('defer', '');

    document.head.appendChild(script);

    googleMapsScriptIsInjected = true;
};

const loadGoogleMapsApi = (apiKey, options = {}) => lazyValue(
    () => new Promise((resolve, reject) => {
        try {
            window.onGoogleMapsApiLoaded = resolve;

            injectGoogleMapsApiScript({
                key: apiKey,
                callback: 'onGoogleMapsApiLoaded',
                ...options
            });
        } catch (error) {
            reject(error);
        }
    }).then(() => window.google.maps)
);

const findinstore = new FindInStore();
export default findinstore;
